/**
 * @generated SignedSource<<1023f8baa3e885dcdeed1fc9dfccf5fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveExtraOptionMutation$variables = {
  additionalAttributeID: string;
  productID: string;
};
export type productSidePanelContent_RemoveExtraOptionMutation$data = {
  readonly removeProductFromAdditionalAttribute: {
    readonly additionalAttributeID: number;
    readonly id: string;
  };
};
export type productSidePanelContent_RemoveExtraOptionMutation = {
  response: productSidePanelContent_RemoveExtraOptionMutation$data;
  variables: productSidePanelContent_RemoveExtraOptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "additionalAttributeID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "additionalAttributeID",
        "variableName": "additionalAttributeID"
      },
      {
        "kind": "Variable",
        "name": "productID",
        "variableName": "productID"
      }
    ],
    "concreteType": "AdditionalAttribute",
    "kind": "LinkedField",
    "name": "removeProductFromAdditionalAttribute",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalAttributeID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveExtraOptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveExtraOptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68869c99e46cf02256e798c98d99e1e4",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveExtraOptionMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveExtraOptionMutation(\n  $additionalAttributeID: ID!\n  $productID: ID!\n) {\n  removeProductFromAdditionalAttribute(additionalAttributeID: $additionalAttributeID, productID: $productID) {\n    id\n    additionalAttributeID\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc4a9e40287768c4deed60d5bbc695e6";

export default node;
